<template>
  <div class="ResetPasswordVerification">
    <v-container fill-height class="mainBackG h-100 loginMain">
      <v-layout row wrap align-center>
        <v-flex class="text-xs-center" xs12 sm12 md12 lg4 style="margin:auto">
          <div class="Formcard align no-shadow card-r">
            <v-form v-model="ResetPasswordVerification" row class="w-100">
              <v-flex xs12 md12 pt-0>
                <v-toolbar flat xs12 class="toolbar ">
                  <div  class="btn-tool text-xs-right">
                    <router-link to="`/resetpassword`" class="aBtn"><v-icon class="textColor">keyboard_arrow_left</v-icon></router-link>
                  </div>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>
                    <h2 class="textColor text-xs-center title">Verificaton</h2>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="hidden-sm-and-down">
                  </v-toolbar-items>
                </v-toolbar>
              </v-flex>

              <v-layout wrap class="logBD">

                <v-flex xs12 sm12>
                  <v-text-field
                    outline
                    label="Enter your Verification Code"
                    v-model="Code"  required></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 pb-0>
                  <v-btn class="btnM mainBackG card-r no-shadow" color="white" :disabled="!ResetPasswordVerification" :to="`/newpassword`">Conform</v-btn>
                </v-flex>

              </v-layout>
            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ResetPasswordVerification",
  data: () => ({
    ResetPasswordVerification: false,
    Code: ""
  })
};
</script>
<style>
  .align{
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-box;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/ResetPasswordVerification.vue